import { render, staticRenderFns } from "./CreateCollection.vue?vue&type=template&id=925d60c6&"
import script from "./CreateCollection.vue?vue&type=script&lang=js&"
export * from "./CreateCollection.vue?vue&type=script&lang=js&"
import style0 from "./CreateCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports